// src/features/permissions/components/PermissionStatusBadge.tsx
import type { PermissionStatus } from '../data/permissions.mock';

export interface PermissionStatusBadgeProps {
  status: PermissionStatus;
}

const STATUS_LABEL: Record<PermissionStatus, string> = {
  active: 'فعال',
  disabled: 'غیرفعال',
};

const STATUS_COLOR_VAR: Record<PermissionStatus, string> = {
  active: 'var(--vania-accent-teal, #2fd6a7)',
  disabled: 'var(--vania-accent-rose, #ff6b81)',
};

/**
 * Small pill badge mapping a role's raw status to its Persian label +
 * accent color. Same status-badge shape used by
 * security/components/SecurityStatusBadge.tsx and
 * analytics/components/AnalyticsStatusBadge.tsx (label map + color-var
 * map keyed by the union type) — kept local to this feature since the
 * union (active/disabled) is permissions-specific.
 */
export function PermissionStatusBadge({ status }: PermissionStatusBadgeProps) {
  const color = STATUS_COLOR_VAR[status];

  return (
    <span className="vania-permissions-status-badge" style={{ color, borderColor: color }}>
      <span aria-hidden className="vania-permissions-status-dot" style={{ backgroundColor: color }} />
      {STATUS_LABEL[status]}
    </span>
  );
}
